var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-checkbox-group',{attrs:{"options":_vm.timeOfDayOption,"name":"timeOfDayOptions"},model:{value:(_vm.selectedTimeOfDay),callback:function ($$v) {_vm.selectedTimeOfDay=$$v},expression:"selectedTimeOfDay"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }